import { Nillable } from '@web/utils';

export class AdminMultimediaDetailsForm {
  public constructor(
    public readonly title: string,
    public readonly alt: Nillable<string>,
    public readonly description: Nillable<string>,
  ) {}
}
